import { Button, Form, IFormRender } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { useToastOpen } from 'contexts/ToastContext';
import { usePositionUpdate } from 'hooks';
import { t } from 'i18next';
import { useRef } from 'react';
import IPosition from 'types/Position';
import { JobCostingPromptOptions } from '__generated__/graphql';
import JobCostingPromptFormFields from '../components/JobCostingPromptFormFields/JobCostingPromptFormFields';

export interface IJobCostingPromptFormData {
  jobCostingPrompt: JobCostingPromptOptions;
}

export interface IJobCostingPromptFormProps {
  className?: ClassName;
  position: IPosition;
  onSubmit: (formData: JobCostingPromptOptions) => void;
}

const JobCostingPromptForm = (props: IJobCostingPromptFormProps) => {
  const { className, position, onSubmit } = props;

  const [, update] = usePositionUpdate();
  const openToast = useToastOpen();

  const initialFormData = useRef<IJobCostingPromptFormData>({
    jobCostingPrompt: position.jobCostingPrompt ?? JobCostingPromptOptions.Off,
  });

  function renderFormFields(form: IFormRender<IJobCostingPromptFormData>) {
    return (
      <>
        <JobCostingPromptFormFields form={form} />
        <Button type="primary" onClick={form.handleSubmit}>
          {t('Update')}
        </Button>
      </>
    );
  }

  async function onFormSubmit(formData: IJobCostingPromptFormData) {
    const updatedValue = {
      jobCostingPrompt: formData.jobCostingPrompt,
    };

    try {
      await update({ ...updatedValue, id: position.id });
    } catch (e) {
      openToast({ label: t('Something went wrong. Please try again later.') });
    }

    onSubmit(updatedValue.jobCostingPrompt);
  }

  const classes = classNames('job-costing-prompt-form', className);

  return (
    <div className={classes}>
      <Form render={renderFormFields} onSubmit={onFormSubmit} data={initialFormData.current} />
    </div>
  );
};

export default JobCostingPromptForm;
